import { generateTable, generateGroupedTable } from "../../../ui/table/Utils.js";
import { roundNumber } from "../../../utils/utils.js";

/**
 * Exported function to register the template
 * 
 * @param {PopupRenderer} renderer static PopupRenderer class
 * 
 * @memberof vef.map.popup.templates
 */
export function satellite(renderer) {

    const template = (content, response, layer, style) => {
        if (!content.features) content = { features: [content] };

        let responses = [];
        for (let i = 0; i < content.features.length; i++) {
            const feature = content.features[i];
            const properties = feature.properties;

            let propertyName = 'Value';
            if (layer.uniqueId.includes("glob_chl1_8_day")) {
                propertyName = "8-day Average";
                properties.GRAY_INDEX = roundNumber(parseFloat(properties.GRAY_INDEX), 4) + " mg/m³";
                properties.SENSOR_URN = `<a target="_blank" href="https://sensor.awi.de/?urn=satellite:glob:chl1:8-day">satellite:glob:chl1:8-day</a>`
            } else if (layer.uniqueId.includes("gcomw1_amsr2_l2_sic")) {
                propertyName = "Sea Ice Concentration";
                properties.GRAY_INDEX = roundNumber(parseFloat(properties.GRAY_INDEX), 4) + " %";
                properties.SENSOR_URN = `<a target="_blank" href="https://sensor.awi.de/?urn=satellite:gcomw1:amsr2:l2:sic">satellite:gcomw1:amsr2:l2:sic</a>`
            }

            let html = "";
            const fields = {};
            if (!style || (style == "popup")) {
                //fields[propertyName] = 'GRAY_INDEX';
                fields["Sensor URN"] = 'SENSOR_URN';

                html = generateTable(properties, { fields: fields });
            } else if (style == "sidebar") {
                fields["Data"] = {};
                //fields["Data"][propertyName] = 'GRAY_INDEX';
                fields["Data"]["Sensor URN"] = 'SENSOR_URN';

                html = document.createElement("div");
                html.insertAdjacentElement("beforeend", generateGroupedTable(properties, fields));

                const abstractTitle = document.createElement("h3");
                abstractTitle.innerText = "Abstract";
                const abstract = document.createElement("p");
                abstract.innerText = layer.abstract;
                const legendTitle = document.createElement("h3");
                legendTitle.innerText = "Legend Graphic";

                html.appendChild(abstractTitle);
                html.appendChild(abstract);
                html.appendChild(legendTitle);
                html.appendChild(layer.getLegendGraphic());
            }

            responses.push({
                response: response,
                feature: feature,
                layer: layer,
                title: layer.title,
                html: html
            });
        }
        return responses;
    };

    renderer.registerTemplate('satellite', template);
}
